import type { ProvenanceClass } from "@/views/PlanOfRecord/planOfRecordData";

/** Provenance colours deliberately avoid the status palette. */
const PROVENANCE_META: Record<
  ProvenanceClass,
  { label: string; className: string; description: string }
> = {
  "user-entered": {
    label: "User entered",
    className: "bg-[#D2EFF9] text-[#06709B]",
    description: "Entered directly in Vivo by a study team member.",
  },
  imported: {
    label: "Imported",
    className: "bg-[#E8EAF6] text-[#3949AB]",
    description:
      "Loaded from an uploaded spreadsheet and confirmed by a user before commit.",
  },
  "vendor-reported": {
    label: "Vendor reported",
    className: "bg-[#FFF3E0] text-[#B26500]",
    description:
      "Supplied by a CRO or vendor feed through ingestion. Read-only in Vivo.",
  },
  "carried-forward": {
    label: "Carried forward",
    className: "bg-[#F3E8FD] text-[#6B21A8]",
    description:
      "Originated in Trial Planning before the trial went live in Vivo.",
  },
};

export function ProvenanceBadge({
  provenance,
}: {
  provenance: ProvenanceClass;
}) {
  const meta = PROVENANCE_META[provenance];

  return (
    <span
      title={meta.description}
      className={`inline-flex h-5 items-center rounded-[4px] px-1.5 text-[12px] font-semibold ${meta.className}`}
    >
      {meta.label}
    </span>
  );
}
